'use strict';

const SectionPickerPresenter = require('../presenters/sectionpicker');

const SeatingSectionsListView = require('./seatingSectionsList');

const BaseView = require('./base');

class SectionSelectorView extends BaseView {
  constructor() {
    super(...arguments);

    this.collection.on('clear', this.clearSelection, this);
    this.collection.on('request', this.clearSelection, this);
    this.model.on(`change:selectedSection`, (model, selection) => {
      this.initializeSectionsListView().options.selectedSection = selection;
      this.render();
    });
  }

  initialize() {
    this.setModule('glive_booking_redesign');
    this.presenter = SectionPickerPresenter;
    this.templateName = 'sectionSelector';
  }

  /*
    The following methods have been adapted from methods
    in the PickerView (./picker.js). NOTE: because the SectionSelector does not
    expand and collapse like the pickers and does not share a container with other
    pickers, it does not require methods that get or set expanded/collapsed status.
  */

  // based on PickerView#content
  initializeSectionsListView() {
    if (!this._content) {
      this._content = new SeatingSectionsListView({
        collection: this.collection,
        selection: this.getSelectedSection(),
      });

      this._content.on('select', this.setSection, this);
      this._content.render();
    }
    return this._content;
  }

  // Automatically selects first section if no selection has been made
  autoSelect() {
    if (!this.getSelectedSection() && this.collection.first() && this.model.get('shouldShowSeating')) {
      this.setSection(this.collection.first());
    }
  }

  // Sets booker model's selectedSection attribute
  setSection(section) {
    return this.model.selectSection(section);
  }

  getSelectedSection() {
    return this.model.get('selectedSection');
  }

  // SectionSelector is not considered "selectable" if its collection
  // contains only 1 selectable section.
  requiresUserSelection() {
    return this.collection.length > 1;
  }

  // Sets booker model's selectedSection to null
  clearSelection() {
    this.setSection(null);
  }

  getContainer() {
    return this.$el.find('.section-selector-container');
  }

  appendSectionsList() {
    return this.initializeSectionsListView().$el.appendTo(this.getContainer());
  }

  render() {
    this.autoSelect();
    this.getContainer()
      .children()
      .detach();
    super.render(...arguments);
    this.appendSectionsList();
    return this;
  }
}

module.exports = SectionSelectorView;
